import { ref, computed } from 'vue';
import { useCurrentUser } from './useCurrentUser';

const TOKEN_KEY = 'auth_token';

// Shared state across all instances
const token = ref(localStorage.getItem(TOKEN_KEY));

export function useAuth() {
  const isAuthenticated = computed(() => !!token.value);

  // Accepts either a raw token string (legacy) or the full login response
  // payload `{token, username, roles}`. When the payload includes user info,
  // seeds useCurrentUser so the dashboard can render role-gated nav without
  // an extra round-trip.
  const login = (payload) => {
    const authToken = typeof payload === 'string' ? payload : payload?.token;
    if (!authToken) {
      console.error('useAuth.login called without a token');
      return;
    }
    token.value = authToken;
    localStorage.setItem(TOKEN_KEY, authToken);

    if (typeof payload === 'object' && payload?.username) {
      useCurrentUser().set({
        username: payload.username,
        roles: payload.roles || [],
      });
    }
  };

  const logout = () => {
    token.value = null;
    localStorage.removeItem(TOKEN_KEY);
    useCurrentUser().clear();
  };

  const getToken = () => {
    return token.value;
  };

  return {
    token,
    isAuthenticated,
    login,
    logout,
    getToken,
  };
}
